export const maxWinAmount = {
    KGS: 3000000,
    RUR: 2500000,
    TJS: 3500000,
    KZT: 15000000,
    USD: 45000,
    EUR: 40000,
    GBP: 35000
};



// WEBPACK FOOTER //
// ./js/constants/StakeMaxWinAmount.js